import Component from 'vue-class-component'
import Vue from 'vue'
import References from '../shared/References.vue'
import statementStore from '../../store/statement/statement-store'
import authStore from '../../store/auth/auth-store'
import { IReference } from '../../model/reference'

@Component({
  name: 'statementReferences',
  props: ['statement'],
  components: { 'references' : References },
})
export default class StatementReferences extends Vue {

  get isEditable () {
    return authStore.user && this.$props['statement'].meta.creator.id === authStore.user.id
  }

  protected addStatementReference (): void {
    statementStore.dispatchAddStatementReference(this.$props['statement'])
  }

  protected removeStatementReference(reference: IReference): void {
    statementStore.dispatchRemoveStatementReference({ statement: this.$props['statement'], reference: reference })
  }

}
